import utils from '@cob/ui-genesis/cob.utils.js';

//Methods for working with escaped (back-slashed) field names and values
//Usually used for parsing strings that we want to split or apply regexes on keyword descriptions, etc.

//Map of chars currently supported chars: key ->escaped char, value -> our escape
var _supportedEscapes = {
    "\\(": "%28",
    '\\)': "%29",
    "\\,": "%2C",
    "\\=": "%3D",
    "\\/": "%2F"
};

//detects escaped chars and substitutes them by our encode
//ex: value="abc \( d \)" will be "abc %28 d %29"
var encodeEscapes = function(value) {
    var _encodedVal = value;
    if(!value) return value;

    utils.forEachOwn(_supportedEscapes, function(escapedChar) {
        //do the equivalent to value.replace(/\\\(/g, "%28")
        var re = new RegExp('\\\\' + escapedChar, "g");
        _encodedVal = _encodedVal.replace(re, _supportedEscapes[escapedChar]);
    });

    return  _encodedVal;
};

// puts back the slashed escapes (usually used after uriEncodeEscapes to put back the value in its original form)
//ex: value="abc %28 d %29" will return to "abc \( d \)"
var decodeEscapes = function(value) {
    var _decodedVal = value;
    if(!value) return value;

    utils.forEachOwn(_supportedEscapes, function(escapedChar) {
        //do the equivalent to value.replace(/%28/g,"\\(")
        var re = new RegExp(_supportedEscapes[escapedChar], "g");
        _decodedVal = _decodedVal.replace(re, escapedChar);
    });

    return  _decodedVal;
};

//removes the escapes completely  (usually used after uriEncodeEscapes and when we need the real field names)
//ex: value="abc %28 d %29" will be to "abc ( d )"
var decodeAndUnescape = function(value) {
    var _decodedVal = value;
    if(!value) return value;

    utils.forEachOwn(_supportedEscapes, function(escapedChar) {
        //do the equivalent to value.replace(/%28/g, "(")
        var re = new RegExp(_supportedEscapes[escapedChar], "g");
        _decodedVal = _decodedVal.replace(re, escapedChar.slice(-1));
    });

    return  _decodedVal;
};

const unQuote = function(value){
   for(const quote of ['"', "'"]) {
      if(value.startsWith(quote) && value.endsWith(quote)){
         return value.slice(1, -1);
      }
   }

   return value;
}

/**
 * Parses field options string with the format "key1: value1, key2, value2, ..."
 *
 * Returns {key1: "value1", key2: "value2", ...}
 *
 * Trims both keys and values.
 * Supports escaped commas and colons: "\\,", "\\:"
 */
const parseOptions = function(optionsArg){
   if((optionsArg ?? '').trim() == '' || (/^[ [\]]+$/).test(optionsArg)) return {};

   return optionsArg
      .replace(/^\[/, '')
      .replace(/]$/, '')
      .replace(/\\,/, '@COB_ENC_COMMA@')
      .replace(/\\:/, '@COB_ENC_COLON@')
      .split(',')
      .map((entry) => entry.split(':'))
      .reduce((obj, kv) => ({
         ...obj,
         [kv[0].trim()]: kv[1].trim().replace('@COB_ENC_COMMA@', ',').replace('@COB_ENC_COLON@', ':')
      }), {});
};

const extendDef = function(def){
   def.isA = function(type){
      return Object.prototype.hasOwnProperty.call(this.configuration.keys, type)
         || Object.prototype.hasOwnProperty.call(this.configuration.extensions, type);
   }.bind(def);

   def.any = function(regexp){
      for(const k in this.configuration.keys){
         if(regexp.test(k)) return k;
      }
      for(const k in this.configuration.extensions){
         if(regexp.test(k)) return k;
      }
      return null;
   }.bind(def);

   def.conf = function(type){
      const conf = this.configuration.keys[type] ?? this.configuration.extensions[type];

      if(typeof conf === 'undefined'){
         throw new Error(`field is not of ${type} type. Can't get conf`);
      }

      return conf;
   }.bind(def);
}

const Keywords = {
   Create            : "Create",
   Date              : "Date",
   DateTime          : "DateTime",
   Default           : "Default",
   EditForGroup      : "EditForGroup",
   Expanded          : "Expanded",
   ExternalReference : "ExternalReference",
   File              : "File",
   ExtFile           : "ExtFile",
   Group             : "Group",
   GroupEdit         : "$groupEdit",
   Help              : "Help",
   Link              : "Link",
   Markdown          : "$markdown",
   MarkedIf          : "MarkedIf",
   Multiple          : "Multiple",
   Number            : "Number",
   Radio             : "$radio",
   Readonly          : "Readonly",
   Reference         : "Reference",
   References        : "References",
   Select            : "Select",
   Style             : "$style",
   Tasks             : "Tasks",
   Text              : "$text",
   Time              : "Time"
}

export { encodeEscapes, decodeEscapes, decodeAndUnescape, unQuote, parseOptions, extendDef, Keywords };
